export default "__VITE_ASSET__o2Sv2_13__"